import spacetime from "spacetime";
import CalendarConfigModel from "./Models/CalendarConfigModel.js";
import CalendarDateModel from "./Models/CalendarDateModel.js";
import CalendarServiceProvider from "./Providers/CalendarServiceProvider.js";
import RestrictionSettingsModel from "./Models/RestrictionSettingsModel.js";
import { getNumericTranslation } from './helpers.js';
// import BookingWidgetController from "./Controllers/BookingWidgetController";
import * as Vue  from 'vue';


// import BookingWidgetConfigModel from "./Models/BookingWidgetConfigModel";
// import BookingWidgetComposable from "./composables/BookingWidgetComposable";
/**
 * @param config {object}
 */
function initCalendar(config)
{
    new CalendarServiceProvider(
        new CalendarConfigModel(config)
    );
}
// function initBookingWidget(config)
// {
//     const instance = new BookingWidgetController(new BookingWidgetConfigModel(config));
//     const elements = document.querySelectorAll(instance.config.elements);
//     elements.forEach(el => {
//         Vue.createApp({
//             name: 'BookingWidget',
//             setup() {
//                 return instance.setup();
//             }
//         }).mount(el);
//     });
// }
/**
 * Set the initCalendar on the window object, so it can be called later.
 */
window.spacetime = spacetime;
window.CalendarDateModel = CalendarDateModel;
window.CalendarConfigModel = CalendarConfigModel;
window.CalendarServiceProvider = CalendarServiceProvider;
window.RestrictionSettingsModel = RestrictionSettingsModel;
window.initCalendar = initCalendar;
window.getNumericTranslation = getNumericTranslation;
// window.initBookingWidget = initBookingWidget;
// window.BookingWidgetComposable = BookingWidgetComposable;
window.Vue = Vue;
